import { CultureInfo } from '../culture-info.model';
import { CultureInfoNl } from './nl';

/**
 * @ignore
 */
export const CultureInfoNlNL: CultureInfo = {
  name: 'nl-NL',
  displayName: 'Dutch (Netherlands)',
  iso3LanguageCode: 'nld',
  iso2LanguageCode: 'nl',
  ietfLanguageTag: 'nl-NL',
  parent: CultureInfoNl
};
